import { Component, OnInit, HostListener, Input  } from '@angular/core';
import { SharedService, AlertService, ApiService } from '../common/service';
import { TranslateService } from '@ngx-translate/core';
import CryptoJS from 'crypto-js';


// tslint:disable: one-variable-per-declaration
@Component({
    selector: 'nexi-form',
    template: require('./nexi.tpl.html')
})
export class NexiComponent implements OnInit {

    @Input() public amount: number = 0;    
    @Input() public minAmount: number = 0;    
    @Input() public tax_amount: number = 0;    
    @Input() public tax_fee: number = 0;

    @Input() public addCard: boolean = false
    @Input() public updateCard: boolean = false    

    @Input() public method: 'charge' | 'store' = 'charge'


    private get nexi_type() : string {
        return 'nexi'
        // return this.sharedService.directopubConfig.autotopup ? 'nexi_rec' : 'nexi'
    }

    /**
     * Chiave pubblica NEXI (ALIAS) - dev: ALIAS_WEB_00048986
     *
     * @readonly
     * @private
     * @memberof NexiComponent
     */
    private get NEXI_API_KEY (): string {       
        return this.sharedService.directopubConfig.billing && this.sharedService.directopubConfig.billing[this.nexi_type] ? 
                this.sharedService.directopubConfig.billing[this.nexi_type].alias : 
                null
    }

    /**
     * Chiave privata NEXI (MAC) - dev: LUZ22ODII0EPM9FAO8Y7QGX2I3IU3JLD
     *
     * @readonly
     * @private
     * @memberof NexiComponent
     */
    private get NEXI_SECRET_KEY (): string {  
        return this.sharedService.directopubConfig.billing && this.sharedService.directopubConfig.billing[this.nexi_type] ? 
                this.sharedService.directopubConfig.billing[this.nexi_type].mac : 
                null        
    }

    // private get NEXI_GROUP (): string {          
    //     return this.sharedService.directopubConfig.billing && this.sharedService.directopubConfig.billing[this.nexi_type] ? 
    //             this.sharedService.directopubConfig.billing[this.nexi_type].group : 
    //             null        
    // }

    public nexiError: string;
    public nexiConfig: any = {};
    public nexiForm: any;
    public nexiAltButtons: any;
    public nexiResponse: any = false;
    public nexiLoading: boolean = true;

    public _nexiPan: boolean;
    public _nexiExpiry: boolean;    
    public _nexiCvv: boolean;
    public nexiFormMounted: boolean = false;

    get hasAutoTopUp():boolean {
        return this.sharedService.directopubConfig && this.sharedService.directopubConfig.autotopup === true
    }

    get XPay() { 
        return window['XPay']; 
    }

    get isNexiProd(): boolean {
        return this.sharedService.directopubConfig.billing.nexi.lib == 'prod'
    }

    get isCharge():boolean {
        return this.method == 'charge'
    }

    get nexiPan():boolean { return this._nexiPan }
    set nexiPan(value) { this._nexiPan = value; this.checkNexiFormMounted() }

    get nexiExpiry():boolean { return this._nexiExpiry }
    set nexiExpiry(value) { this._nexiExpiry = value;  this.checkNexiFormMounted() }

    get nexiCvv():boolean { return this._nexiPan }
    set nexiCvv(value) { this._nexiCvv = value;  this.checkNexiFormMounted() }

    get nexiAltButtonsShow(): boolean {
        return this.sharedService.directopubConfig.billing.nexi.alt_payments
    }

    constructor(
        private translate: TranslateService,
        public sharedService: SharedService,
        public alertService: AlertService,
        public api: ApiService
    ) { 
// console.log('this.shared',this.sharedService.directopubConfig.autotopup)
    }

    ngOnInit(): void {
        
        if ( ! this.XPay ) {           
            if ( this.isNexiProd ) {
                $('head').append('<script src="https://ecommerce.nexi.it/ecomm/XPayBuild/js?alias='+this.NEXI_API_KEY+'"></script>')
            } else {
                $('head').append('<script src="https://int-ecommerce.nexi.it/ecomm/XPayBuild/js?alias='+this.NEXI_API_KEY+'"></script>')
            }
        }

    }

    /**
     * Verifica se tutti i 3 campi del form di nexi sono stati caricati
     * 
     */
    public checkNexiFormMounted(): void {        
        this.nexiFormMounted = this.nexiPan && this.nexiExpiry && this.nexiCvv
        this.nexiLoading = !this.nexiFormMounted
    }

    /**
     * Mappa il codice lingua interno in quello di nexi
     * 
     * @param {string} lang codice lingua interno
     * @returns {string} codice lingua nexi
     */
    public getNexiLanguageCode(lang:string): string {

        let languages = {
            'it' : this.XPay.LANGUAGE.ITA,
            'en' : this.XPay.LANGUAGE.ENG,
            'es' : this.XPay.LANGUAGE.SPA,
            'pt' : this.XPay.LANGUAGE.POR
        }

        return languages[lang] || languages['en']
    }

    /**
     * Converte il codice valuta interno in quello di nexi
     * 
     * @param {string} currency codice valuta interno
     * @returns {string} codice valuta nexi
     */
    public getNexiCurrencyCode(currency): string {

        let currencies = {
            'EUR' : '978',
        }

        return currencies[currency] || null

    }

    /**
     * Calcolo dell'amount da inviare a Nexi comprensivo di eventuali tasse
     *
     * @readonly
     * @type {number}
     * @memberof NexiComponent
     */
    public get nexiAmount():number {

        if ( ! this.isCharge ) 
            return 0

        let amount = Math.round( +this.amount * 100 )
        
        if ( this.tax_fee > 0 ) {
            amount += ( amount * this.tax_fee ) / 100
            amount = Math.round( amount )
        } else

        if ( this.tax_amount > 0 ) {
            amount += Math.round( +this.tax_amount * 100 )
        }

        return amount

    }

    /**
     * Inizializza il metodo di pagamento
     *      1. configura il plugin
     *      2. visualizza i campi della carta nei tre div 
     * 
     * @returns void
     */
    public initNexiPayment(): void {
            
        let time          = Date.now();
        let transactionId = 'code_' + time;
        let currency      = this.getNexiCurrencyCode('EUR');  // Solamente EUR valida
        let language      = this.getNexiLanguageCode(this.sharedService.language)
        let amount        = this.nexiAmount
        let mac           = CryptoJS.SHA1("codTrans=" + transactionId + "divisa=" + currency + "importo=" + amount + this.NEXI_SECRET_KEY);
        let url           = "https://www.merchant-server.it/build/url.php";
        let urlBack       = "https://www.merchant-server.it/build/urlBack.php";
        // let urlPost    = "https://www.merchant-server.it/build/urlPost.php";

        if ( ! currency ) {
            this.nexiResponse = {
                "status": "error",                
                "message": this.translate.translations[this.sharedService.language].BILLING.BRAINTREE.genericError
            }
            console.error('Currency not supported by Nexi')
            return;
        }        

        if ( ! this.NEXI_API_KEY || ! this.NEXI_SECRET_KEY ) {
            this.nexiResponse = {
                "status": "error",                
                "message": this.translate.translations[this.sharedService.language].BILLING.BRAINTREE.genericError
            }
            console.error('Keys not found')
            return
        }


        this.nexiResponse = false

        this.XPay.init();      
        
        this.nexiConfig = {
            baseConfig: {
                apiKey: this.NEXI_API_KEY,
                enviroment: this.isNexiProd ? this.XPay.Environments.PROD : this.XPay.Environments.INTEG
            },
            paymentParams: {
                amount: amount,
                transactionId: transactionId,
                currency: currency,
                timeStamp: time,
                mac: mac.toString(),
                url: url,
                urlBack: urlBack,
            },        
            customParams: {},
            language: language
        };

        if ( this.method == 'store' ) {
            this.nexiConfig['requestType'] = 'PP'
            this.nexiConfig['serviceType'] = 'paga_multi'

            // this.nexiConfig['customParams'] = {
            //     'num_contratto' : 'NUM_12374_1675691357'
            // }

            // if ( this.NEXI_GROUP != '' )
            //     this.nexiConfig.paymentParams['gruppo'] = this.NEXI_GROUP
        }

        // console.log('this.nexiConfig',this.nexiConfig)

        this.XPay.setConfig(this.nexiConfig);

        let infoSicurezza = {
            transType : "01"
        };
                
        this.XPay.setInformazioniSicurezza(infoSicurezza);
            
        let style = {
            common: {
                fontSize: "1.15em",
                color: "#343434"
            },
            error:{
                color: "#ff0000",
            }            
        };

        // let acceptedCards = [XPay.CardBrand.MASTERCARD, XPay.CardBrand.VISA]

        this.nexiForm = this.XPay.create(this.XPay.OPERATION_TYPES.SPLIT_CARD, style, []);
        this.nexiForm.mount("xpay-pan", "xpay-expiry", "xpay-cvv");

        if ( this.isCharge && this.nexiAltButtonsShow ) {
            let acceptedAltPayments = [this.XPay.PaymentMethods.PAYPAL]
            // let acceptedAltPayments = []        
            this.nexiAltButtons = this.XPay.create(this.XPay.OPERATION_TYPES.PAYMENT_BUTTON, acceptedAltPayments);
            this.nexiAltButtons.mount("xpay-btn");
        }

        
        
    }

    /**
     * Crea il Nonce univoco per effettuare il pagamento
     * 
     */
    public createNexiPayment() {
        this.nexiLoading = true
        this.XPay.createNonce("nexi-payment-form", this.nexiForm);
    }


    /**
     * Annulla la procedura
     * 
     */
    public resetNexiPayment(): void {
        let text = this.translate.translations[this.sharedService.language].BILLING.NEXI.CONFIRM_EXIT
        if (confirm(text)) {
            this.reloadPage()
        }      
    }

    public reloadPage(): void {        
        window.location.reload()        
    }

    public savePayment(postData) {

        let url = this.isCharge ? 'nexi/transaction-sale' : 'nexi/register-card'

        return this.api.post(url,postData)
            .toPromise()
            .then(
                success => {
                    // console.log('SUCCESS',success)
                    this.nexiResponse = {
                        "status": "success",
                        "message": this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_SUCCESS            
                    };                        
                }
            ).catch(                    
                err => {
                    console.error('Payment error', err.message)
                    
                    let message = this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_ERROR
                    if ( err.code == 'Error_Transfer' ) message = this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_ERROR_TRANSFER
                    if ( err.code == 'Nexi_Error' ) message = (JSON.parse(err.message)).messaggio
                                            
                    this.nexiResponse = {
                        "status": "error",                           
                        "message": message
                    }

                }
            )

    }

    /**
     * Evento generato al "montaggio" del singolo campo nel div relativo
     * 
     * @param event 
     */
    @HostListener('window:XPay_Ready',['$event']) _XPay_Ready (event) {   

        switch (event.detail) {
            case 'PAN':
                this.nexiPan = true
                break;                
            case 'EXPIRY':
                this.nexiExpiry = true
                break;                
            case 'CVV':
                this.nexiCvv = true
                break;            
        }
    }

    /**
     * Evento generato solamente in caso di pagamento tramite metodo alternativo (paypal)
     * 
     * @param event 
     */
    @HostListener('window:XPay_Payment_Started',['$event']) _XPay_Payment_Started (event) {
        // console.log('Metodo selezionato dall\'utente: ' + event.detail);
        this.nexiLoading = true
    }

    /**
     * Evento generato solamente in caso di pagamento tramite metodo alternativo (paypal)
     * 
     * @param event 
     */
    @HostListener('window:XPay_Payment_Result',['$event']) _XPay_Payment_Result (event) {
        let response = event.detail;
        // console.log('XPAY_PAYPAL EVENT', event, response)
        if ( response.esito && response.esito == 'OK' ) {

            // BILLINGAGREEMENTACCEPTEDSTATUS: "0"
            // PAYERID: "D9Q96WABJ4KKJ"
            // PAYMENTINFO_0_TRANSACTIONID: "01R415278W447830V"
            // alias: "ALIAS_WEB_00048986"
            // brand: "PAYPAL"
            // codAut: "paypal"
            // codTrans: "code_1674034286156"
            // codiceEsito: "0"
            // data: "20230118"
            // divisa: "EUR"
            // esito: "OK"
            // importo: "244"
            // mac: "0dcf8208a5a26caa3812e6957beea39875d87aba"
            // mail: "sb-xhrae9109672@personal.example.com"
            // messaggio: "Transazione avvenuta correttamente"
            // numeromerchant: "00048986"
            // orario: "103152"
            // tipoTransazione: "PAYPAL"

            // response.divisa = this.nexiConfig.paymentParams.currency

            let postData = {
                "amount": +this.amount * 100, 
                "codice_transazione": this.nexiConfig.paymentParams.transactionId,
                "divisa":  this.nexiConfig.paymentParams.currency,
                "advertiser_id": this.sharedService.advertiser.id,
                "payment_type": "ALTERNATE",
                "response": response
                // ...response
            }

            // console.log('POST DATA',postData)
            this.savePayment(postData)

            // this.nexiResponse = {
            //     "status": "success",                               
            //     "message": response && response.messaggio ? 
            //         response.messaggio : 
            //         this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_SUCCESS 
            // }

        } else {

            this.nexiResponse = {
                "status": "error",                
                "message": response && response.esito == 'ANNULLO' ? 
                    this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_CANCELED : 
                    this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_ERROR
            }

        }
    }

    /**
     * Evento generato al controllo dei dati della carta
     * 
     * @param event 
     */
    @HostListener('window:XPay_Card_Error',['$event']) _XPay_Card_Error (event) {
        this.nexiError = event.detail && event.detail.errorMessage || null;        
        this.nexiLoading = false
    }

    /**
     * Evento generato in risposta alla creazione del Nonce
     * In caso di successo esegue la chiamata al nostro backend per effettuare il pagamento
     * altrimenti genera un messaggio di errore 
     * 
     * @param event 
     */
    @HostListener('window:XPay_Nonce',['$event']) _XPay_Nonce(event) {
        
        var response = event.detail;
        this.nexiLoading = true;
        // console.log('RESPONSE XPay_Nonce',response)
        
        if (response.esito && response.esito === "OK") {

            let postData = {
                "payment_method_nonce": response.xpayNonce,
                "amount": +this.amount * 100, //this.nexiConfig.paymentParams.amount,
                "codice_transazione": this.nexiConfig.paymentParams.transactionId,
                "divisa":  this.nexiConfig.paymentParams.currency,
                "xpay_esito": response.esito,
                "xpay_id_operazione": response.idOperazione,
                "xpay_timestamp": response.timeStamp,
                "xpay_mac": response.mac,
                "advertiser_id": this.sharedService.advertiser.id,
                "payment_type": 'DIRECT',
                // "save_payment_methods": this.nexiRequest.save_payment_methods
            }

            // console.log('POST',postData)
            this.savePayment(postData)
            
        } else {

            this.nexiResponse = {
                "status": "error",                
                "message": response.errore && response.errore.messaggio ? 
                    response.errore.messaggio :
                    this.translate.translations[this.sharedService.language].BILLING.NEXI.PAYMENT_ERROR
            }

        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/billing/nexi.component.ts